module.exports = __webpack_public_path__ + "img/base_divers_agenda.e7ef2f2f.svg";